import { render, staticRenderFns } from "./search-brand.vue?vue&type=template&id=e668c7ca&scoped=true&"
import script from "./search-brand.vue?vue&type=script&lang=js&"
export * from "./search-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e668c7ca",
  null
  
)

export default component.exports